import axios, { type AxiosResponse } from 'axios';

import Log from '@/Logger';
import { getAccessToken } from '@/auth';

function getEwbReqId(resp: any) {
    return resp?.headers?.['ricoh-ewb-request-id'] ?? '-';
}

const GRAPHQL_API_URL = import.meta.env.VITE_GRAPHQL_API_URL ?? '';

type Input = {
    [key: string]: Input | string | number | boolean
}

type GraphQLBody = any;

function apiCall<T>(method: 'deleteDocument', inputType: 'DeleteDocumentInput', input: Input, output: string[]): Promise<AxiosResponse<T, GraphQLBody>>;
function apiCall<T>(method: "getLinkServiceToken", inputType: "GetLinkServiceTokenInput", input: Input, output: string[]): Promise<AxiosResponse<T, GraphQLBody>>;

async function apiCall<T>(method: string, inputType: string, input: Input, output: string[]): Promise<AxiosResponse<T, GraphQLBody>> {
    const logger = Log.getLogger();

    logger.api.info('Cognito', 'Start to request: currentSession');
    const token = await getAccessToken();
    logger.api.info('Cognito', 'Succeed to request: currentSession');

    const apiResponse: AxiosResponse<T, GraphQLBody> = await axios.post<T>(
        GRAPHQL_API_URL,
        `{"query": "mutation($input:${inputType}!) { ${method}(input:$input) { ${output.join(', ')} }}", "variables": { "input": ${JSON.stringify(input)} }}`,
        {
            headers: {
                'Content-Type': 'application/graphql',
                'Authorization': 'Bearer ' + token
            }
        }
    );

    return apiResponse;
}


/**
 * kintoneのREST APIを実行するためのトークンを取得する関数。
 *
 * @returns トークンとkintoneアプリのドメインを持つオブジェクト{token, endpoint}を返します。取得に失敗した場合はtokenとendpointに空文字が入ります。
 */
export async function getKintoneToken(): Promise<{ token: string, endpoint: string }> {
    const logger = Log.getLogger();
    logger.api.info('Lantana-API', 'Start to request: getLinkServiceToken');

    const inputObj: Input = { "service": "kintone" };
    const outputObj: string[] = ["accessToken{token expiredDate} endpointUrl"];
    const resp = await apiCall<{ data: any, errors: any }>('getLinkServiceToken', 'GetLinkServiceTokenInput', inputObj, outputObj);
    if (resp.data.errors && resp.data.errors.length && resp.data.errors.length > 0) {
        const reqId = getEwbReqId(resp);
        const msg = `Failed to execute kintoneToken API: name=getLinkServiceToken, service=kintone, id=${reqId}`;
        logger.api.error('Lantana-API', msg, resp.headers);
        return { token: '', endpoint: '' };
    }

    logger.api.info('Lantana-API', 'Succeed to request: getLinkServiceToken', resp.headers);

    const token = (resp.data?.data?.getLinkServiceToken?.accessToken?.token ?? "") as string;
    const endpoint = (resp.data?.data?.getLinkServiceToken?.endpointUrl ?? "") as string;

    return { token, endpoint };

}
